import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana60Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1466_23555)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("4"))}
        d="M336.387 477.63L369.124 456.797L398.884 502.926L357.218 529.711C351.763 520.287 339.661 499.95 334.899 493.998C330.137 488.046 333.907 480.606 336.387 477.63Z"
        fill={getFillByLot(4, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("5"))}
        d="M379.543 566.91L357.223 529.709L397.4 504.412L425.673 555.006C419.721 558.974 405.733 568.101 397.4 572.862C389.067 577.624 382.023 570.878 379.543 566.91Z"
        fill={getFillByLot(5, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("6"))}
        d="M465.847 529.711L425.669 555.008L397.396 504.414L437.574 479.117L465.847 529.711Z"
        fill={getFillByLot(6, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("7"))}
        d="M507.514 504.412L465.849 529.709L437.576 479.115L476.265 453.818L507.514 504.412Z"
        fill={getFillByLot(7, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("8"))}
        d="M547.69 479.115L507.513 504.412L476.264 453.819L516.441 430.01L547.69 479.115Z"
        fill={getFillByLot(8, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("3"))}
        d="M412.278 430.01L369.125 456.795L398.886 502.924L442.039 476.139L412.278 430.01Z"
        fill={getFillByLot(3, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("2"))}
        d="M453.949 403.225L412.283 430.009L442.044 476.139L483.71 449.354L453.949 403.225Z"
        fill={getFillByLot(2, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("1"))}
        d="M474.766 389.834L453.934 403.227L483.695 449.357L541.728 415.131C527.344 408.187 495.599 392.215 489.647 389.834C483.695 387.453 477.246 388.842 474.766 389.834Z"
        fill={getFillByLot(1, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("9"))}
        d="M589.354 453.816L547.688 479.113L516.439 430.007L541.736 415.127L589.536 436.854C590.394 437.244 591.163 437.822 591.699 438.598C595.542 444.161 594.922 449.64 589.354 453.816Z"
        fill={getFillByLot(9, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1466_23555"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1466_23555"
            transform="matrix(0.00204111 0 0 0.00270596 -2.41421 -2.03479)"
          />
        </pattern>
        <image
          id="image0_1466_23555"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
